import { FC, SVGAttributes } from 'react';
import Plus from './plus';
import Home from '@components/icons/home';
import Notification from '@components/icons/notification';
import NavDown from '@components/icons/nav_down';
import Close from '@components/icons/close';
import Check from '@components/icons/check';
import ArrowLeft from '@components/icons/arrow_left';
import ArrowRight from '@components/icons/arrow_right';
import Burger from '@components/icons/burger';
import CloseOutlined from '@components/icons/close_outlined';
import Reward from '@components/icons/reward';
import ErrorFilled from '@components/icons/error_filled';
import NavLeft from '@components/icons/nav_left';
import NavRight from '@components/icons/nav_right';
import SettingsFilled from '@components/icons/settings_filled';
import MoreVertical from '@components/icons/more_vertical';
import Trash from '@components/icons/trash';
import CreditCard from '@components/icons/credit_card';
import AccountBalance from '@components/icons/account_balance';
import Download from '@components/icons/download';
import MoreHorizontal from '@components/icons/more_horizontal';
import Language from '@components/icons/language';
import Search from '@components/icons/search';
import Attach from '@components/icons/attach';
import Edit from '@components/icons/edit';
import CloseWorld from '@components/icons/close_world';
import Share from '@components/icons/share';
import Clock from '@components/icons/clock';
import Calendar from '@components/icons/calendar';
import Bitcoin from '@components/icons/bitcoin';
import Sync from '@components/icons/sync';
import ClosedEye from '@components/icons/closed_eye';
import CheckOutline from '@components/icons/check_outline';
import Cloud from '@components/icons/cloud';
import Lock from '@components/icons/lock';
import Money from '@components/icons/money';
import Pin from '@components/icons/pin';
import Power from '@components/icons/power';
import LockOpened from '@components/icons/lock_opened';
import Delete from '@components/icons/delete';
import Settings from '@components/icons/settings';
import Limit from '@components/icons/limit';
import Person from '@components/icons/person';
import Send from '@components/icons/send';
import Upload from '@components/icons/upload';
import Task from '@components/icons/task';
import Warning from '@components/icons/warning';
import Interac from '@components/icons/interac';
import ErrorOutlined from '@components/icons/error_outlined';
import Headset from '@components/icons/headset';
import Atm from '@components/icons/atm';
import Bank from '@components/icons/bank';
import Link from '@components/icons/link';
import Filter from '@components/icons/filter';
import Minus from '@components/icons/minus';
import CheckCheckbox from '@components/icons/check_checkbox';
import SelectArrow from '@components/icons/select_arrow';
import OpenEye from '@components/icons/open_eye';
import ArrowUp from '@components/icons/arrow_up';
import ArrowDown from '@components/icons/arrow_down';
import Canadian from '@components/icons/canadian';
import MoneyIn from '@components/icons/money_in';
import MoneyOut from '@components/icons/money_out';
import Amex from '@components/icons/amex';
import Visa from '@components/icons/visa';
import Mastercard from '@components/icons/mastercard';
import Discover from '@components/icons/discover';
import Business from '@components/icons/business';
import Camera from '@components/icons/camera';
import Email from '@components/icons/email';
import Favorite from '@components/icons/favorite';
import Refresh from '@components/icons/refresh';
import Yen from '@components/icons/yen';
import Dollar from '@components/icons/dollar';
import Info from '@components/icons/info';
import Pause from '@components/icons/pause';
import Play from '@components/icons/play';
import LoadingSpinner from '@components/icons/loading_spinner';
import Schedule from '@components/icons/schedule';
import Gift from '@components/icons/gift';
import Block from '@components/icons/block';
import Watches from '@components/icons/watches';
import CashBank from '@components/icons/cash_bank';
import Question from '@components/icons/question';
import Logout from '@components/icons/logout';
import Chat from '@components/icons/chat';
import UploaderIcon from '@components/icons/uploader_icon';
import UploadedFileFormat from '@components/icons/uploaded_file_format';
import ErrorTriangle from '@components/icons/error_triangle';
import FiledClose from '@components/icons/filed_close';
import DoubleCheck from '@components/icons/double_check';
import FilledCard from '@components/icons/filled_card';
import FilledBank from '@components/icons/filled_bank';
import RequestMoney from '@components/icons/request_money';
import At from '@components/icons/at';
import AddPerson from '@components/icons/add_person';
import Ghost from '@components/icons/ghost';
import AddPayee from '@components/icons/add_payee';
import PayBill from '@components/icons/pay_bill';
import LinkBank from '@components/icons/link_bank';
import LinkCard from '@components/icons/link_card';
import FilledWallet from '@components/icons/filled_wallet';
import Delivery from '@components/icons/delivery';
import Document from '@components/icons/document';
import Copy from '@components/icons/copy';
import CalendarCheck from '@components/icons/calendar_check';
import Reload from '@components/icons/reload';
import MapPointer from '@components/icons/map_pointer';
import Star from '@components/icons/star';
import StarFilled from '@components/icons/star_filled';
import ShieldKey from '@components/icons/shield_key';
import FilledCheck from '@components/icons/filled_check';
import Sms from '@components/icons/sms';
import Print from '@components/icons/print';
import FilledCamera from '@components/icons/filled_camera';
import OutlinedPlus from '@components/icons/outlined_plus';
import OutlinedMinus from '@components/icons/outlined_minus';
import KYC from '@components/icons/kyc';
import Identity from '@components/icons/identity';
import Bulb from '@components/icons/bulb';
import UploadCloud from '@components/icons/upload_cloud';
import Coins from '@components/icons/coins';
import History from '@components/icons/history';
import Award from '@components/icons/award';
import Restart from '@components/icons/restart';
import FilledWarning from '@components/icons/filled_warning';
import Phone from '@components/icons/phone';
import ExternalLink from './external_link';
import Loyalty from '@components/icons/loyalty';
import TransactionArrowDown from './transaction_arrow_down';
import TransactionArrowUp from './transaction_arrow_up';
import TransactionArrowRecurring from './transaction_arrow_recurring';
import Tier from './tier';
import Freeze from './freeze';
import Heat from './heat';
import ExternalPerson from './external_person';
import ReplaceCard from './replace_card';
import FilledInfo from './filled_info';
import GiftCard from './gif_card';
import Redeem from './redeem';
import Key from './key';
import Igaming from './igaming';
import OutlinedWallet from './outlined_wallet';
import TickCircle from './tick_circle';
import Receipt from './receipt';
import Code from './code';

export type TIconType =
    | 'home'
    | 'minus'
    | 'igaming'
    | 'outlined_wallet'
    | 'uploaded_file_format'
    | 'check_checkbox'
    | 'notification'
    | 'replace_card'
    | 'star'
    | 'star_filled'
    | 'filled_wallet'
    | 'shield_key'
    | 'nav_down'
    | 'add_person'
    | 'gift_card'
    | 'close'
    | 'check'
    | 'link_card'
    | 'external_link'
    | 'transaction_arrow_up'
    | 'transaction_arrow_down'
    | 'link_bank'
    | 'print'
    | 'plus'
    | 'reload'
    | 'error_triangle'
    | 'upload_cloud'
    | 'tier'
    | 'marketing'
    | 'arrow_left'
    | 'arrow_down'
    | 'arrow_up'
    | 'calendar_check'
    | 'select_arrow'
    | 'arrow_right'
    | 'question'
    | 'watches'
    | 'outlined_plus'
    | 'loading_spinner'
    | 'burger'
    | 'uploader'
    | 'loyalty'
    | 'business'
    | 'filled_info'
    | 'filled_camera'
    | 'close_outlined'
    | 'freeze'
    | 'heat'
    | 'reward'
    | 'favorite'
    | 'phone'
    | 'redeem'
    | 'award'
    | 'error_filled'
    | 'nav_left'
    | 'kyc'
    | 'nav_right'
    | 'identity'
    | 'camera'
    | 'settings_filled'
    | 'filed_close'
    | 'copy'
    | 'more_vertical'
    | 'trash'
    | 'credit_card'
    | 'account_balance'
    | 'download'
    | 'more_horizontal'
    | 'ghost'
    | 'filled_check'
    | 'filled_warning'
    | 'language'
    | 'key'
    | 'search'
    | 'sms'
    | 'attach'
    | 'edit'
    | 'close_world'
    | 'share'
    | 'clock'
    | 'calendar'
    | 'schedule'
    | 'bitcoin'
    | 'sync'
    | 'delivery'
    | 'closed_eye'
    | 'check_outlined'
    | 'cloud'
    | 'lock'
    | 'document'
    | 'money'
    | 'pin'
    | 'power'
    | 'lock_opened'
    | 'delete'
    | 'settings'
    | 'block'
    | 'limit'
    | 'person'
    | 'send'
    | 'upload'
    | 'task'
    | 'warning'
    | 'play'
    | 'interac'
    | 'error_outlined'
    | 'headset'
    | 'restart'
    | 'atm'
    | 'bank'
    | 'amex'
    | 'visa'
    | 'mastercard'
    | 'map_pointer'
    | 'history'
    | 'discover'
    | 'gift'
    | 'link'
    | 'add_payee'
    | 'open_eye'
    | 'canadian'
    | 'cash_bank'
    | 'coins'
    | 'pause'
    | 'refresh'
    | 'info'
    | 'money_in'
    | 'outlined_minus'
    | 'yen'
    | 'dollar'
    | 'logout'
    | 'money_out'
    | 'chat'
    | 'email'
    | 'pay_bill'
    | 'double_check'
    | 'filled_bank'
    | 'filled_card'
    | 'request_money'
    | 'transaction_arrow_recurring'
    | 'bulb'
    | 'at'
    | 'external_person'
    | 'filter'
    | 'tick_circle'
    | 'receipt'
    | 'code';

export type TIconConfig = {
    component: FC<SVGAttributes<SVGElement>>;
};

const svgIconsConfig: Record<TIconType, TIconConfig> = {
    plus: { component: Plus },
    external_person: { component: ExternalPerson },
    delivery: { component: Delivery },
    tier: { component: Tier },
    identity: { component: Identity },
    outlined_wallet: { component: OutlinedWallet },
    logout: { component: Logout },
    outlined_plus: { component: OutlinedPlus },
    filled_wallet: { component: FilledWallet },
    igaming: { component: Igaming },
    replace_card: { component: ReplaceCard },
    request_money: { component: RequestMoney },
    question: { component: Question },
    filled_card: { component: FilledCard },
    bulb: { component: Bulb },
    filled_bank: { component: FilledBank },
    upload_cloud: { component: UploadCloud },
    copy: { component: Copy },
    at: { component: At },
    transaction_arrow_up: { component: TransactionArrowUp },
    transaction_arrow_down: { component: TransactionArrowDown },
    coins: { component: Coins },
    kyc: { component: KYC },
    key: { component: Key },
    filled_check: { component: FilledCheck },
    star: { component: Star },
    filled_warning: { component: FilledWarning },
    star_filled: { component: StarFilled },
    filled_info: { component: FilledInfo },
    chat: { component: Chat },
    double_check: { component: DoubleCheck },
    favorite: { component: Favorite },
    filed_close: { component: FiledClose },
    restart: { component: Restart },
    map_pointer: { component: MapPointer },
    outlined_minus: { component: OutlinedMinus },
    pause: { component: Pause },
    link_bank: { component: LinkBank },
    link_card: { component: LinkCard },
    external_link: { component: ExternalLink },
    pay_bill: { component: PayBill },
    freeze: { component: Freeze },
    heat: { component: Heat },
    phone: { component: Phone },
    history: { component: History },
    award: { component: Award },
    redeem: { component: Redeem },
    yen: { component: Yen },
    shield_key: { component: ShieldKey },
    calendar_check: { component: CalendarCheck },
    add_person: { component: AddPerson },
    ghost: { component: Ghost },
    watches: { component: Watches },
    loading_spinner: { component: LoadingSpinner },
    schedule: { component: Schedule },
    transaction_arrow_recurring: { component: TransactionArrowRecurring },
    marketing: { component: Schedule },
    dollar: { component: Dollar },
    add_payee: { component: AddPayee },
    reload: { component: Reload },
    print: { component: Print },
    info: { component: Info },
    cash_bank: { component: CashBank },
    refresh: { component: Refresh },
    uploader: { component: UploaderIcon },
    open_eye: { component: OpenEye },
    select_arrow: { component: SelectArrow },
    check_checkbox: { component: CheckCheckbox },
    error_triangle: { component: ErrorTriangle },
    sms: { component: Sms },
    minus: { component: Minus },
    home: { component: Home },
    notification: { component: Notification },
    loyalty: { component: Loyalty },
    nav_down: { component: NavDown },
    close: { component: Close },
    check: { component: Check },
    arrow_left: { component: ArrowLeft },
    arrow_right: { component: ArrowRight },
    burger: { component: Burger },
    gift: { component: Gift },
    business: { component: Business },
    uploaded_file_format: { component: UploadedFileFormat },
    block: { component: Block },
    close_outlined: { component: CloseOutlined },
    reward: { component: Reward },
    error_filled: { component: ErrorFilled },
    gift_card: { component: GiftCard },
    nav_left: { component: NavLeft },
    canadian: { component: Canadian },
    nav_right: { component: NavRight },
    filled_camera: { component: FilledCamera },
    settings_filled: { component: SettingsFilled },
    more_vertical: { component: MoreVertical },
    trash: { component: Trash },
    credit_card: { component: CreditCard },
    account_balance: { component: AccountBalance },
    download: { component: Download },
    more_horizontal: { component: MoreHorizontal },
    language: { component: Language },
    search: { component: Search },
    attach: { component: Attach },
    camera: { component: Camera },
    edit: { component: Edit },
    close_world: { component: CloseWorld },
    share: { component: Share },
    clock: { component: Clock },
    calendar: { component: Calendar },
    bitcoin: { component: Bitcoin },
    sync: { component: Sync },
    closed_eye: { component: ClosedEye },
    play: { component: Play },
    check_outlined: { component: CheckOutline },
    cloud: { component: Cloud },
    lock: { component: Lock },
    money: { component: Money },
    pin: { component: Pin },
    power: { component: Power },
    lock_opened: { component: LockOpened },
    delete: { component: Delete },
    document: { component: Document },
    settings: { component: Settings },
    limit: { component: Limit },
    person: { component: Person },
    send: { component: Send },
    upload: { component: Upload },
    task: { component: Task },
    warning: { component: Warning },
    interac: { component: Interac },
    error_outlined: { component: ErrorOutlined },
    headset: { component: Headset },
    atm: { component: Atm },
    bank: { component: Bank },
    link: { component: Link },
    arrow_up: { component: ArrowUp },
    arrow_down: { component: ArrowDown },
    filter: { component: Filter },
    money_in: { component: MoneyIn },
    money_out: { component: MoneyOut },
    amex: { component: Amex },
    visa: { component: Visa },
    mastercard: { component: Mastercard },
    email: { component: Email },
    discover: { component: Discover },
    tick_circle: { component: TickCircle },
    receipt: { component: Receipt },
    code: { component: Code }
};

export interface IIcon {
    name: TIconType;
    height?: number;
    width?: number;
    className?: string;
}

export const Icon: FC<IIcon & SVGAttributes<SVGElement>> = ({
    name,
    width = 24,
    height = 24,
    ...props
}) => {
    const IconComponent = svgIconsConfig[name]?.component;

    return <IconComponent width={width} height={height} {...props} />;
};
